import React, {useContext} from 'react';
import PropTypes from 'prop-types';
import {Form, Input as UInput} from '@rocketseat/unform';
import {Spinner, Button, Input} from 'reactstrap';
import I18nMessage from '../../components/I18nMessage';
import {ThemeContext} from '../../apiContexts';
import styled from 'styled-components';


const LoginForm = (props) => {
    const {
        error,
        clear,
        schema,
        loading,
    } = props;

    const theme = useContext(ThemeContext);

    const LoginButtonStyled = styled(Button)`
    color: #FFFFFF;
    background-color: ${(props) => props.theme} !important;
    border-color: ${(props) => props.theme};
    `;
    return (
        <div className="wrapper fadeInDown">
            <div id="formContent">

                <div className="fadeIn first">
                    <img
                        src={`${process.env.PUBLIC_URL}/images/logo.png`}
                        alt="logo"
                        width="300"
                    />
                </div>

                <Form schema={schema}
                      className="login100-form validate-form"
                      onSubmit={props.onLogin}
                >
                    <br/>
                    <div className={'form-item'}>
                        <Input
                            onChange={() => clear()}
                            className="form__input"
                            tag={UInput}
                            type="email"
                            name="email"
                            placeholder={'E-mail'}
                            id="email"
                        />
                    </div>
                    <br/>
                    <div className={'form-item'}>
                        <Input
                            onChange={() => clear()}
                            className="form__input"
                            tag={UInput}
                            type="password"
                            name="password"
                            id="password"
                            placeholder={'Senha'}
                            autoComplete={'new-password'}
                        />
                    </div>

                    <div style={{padding: 20}}>
                        <LoginButtonStyled className="btn btn-primary btn-lg btn-block" theme={theme}>
                            {loading ? <Spinner
                                    as="span"
                                    animation="border"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                /> :
                                <I18nMessage id="loginTitle"/>}
                        </LoginButtonStyled>
                    </div>

                    <div className="text-center p-t-46 p-b-20">
                        {error && <span className="txt-error">
                <I18nMessage id="errorAuthorization"/>
              </span>}
                    </div>

                    <div className={'row'}>
                        <div className={'col'} style={{paddingTop: 8}}>
                            <a className={'ios-button'}
                               href="https://apps.apple.com/br/app/tracking-brasil-rastreamento/id1523109238">&nbsp;</a>
                        </div>
                        <div className={'col'}>
                            <a
                                href='https://play.google.com/store/apps/details?id=com.azultecnologia.monitor.mobile.trackingbrasil'>
                                <img width="155" alt='Disponível no Google Play'
                                     src='https://play.google.com/intl/pt-BR/badges/static/images/badges/pt-br_badge_web_generic.png'/></a>
                        </div>
                    </div>

                </Form>
            </div>
            <footer>
                <a href="https://statuspage.freshping.io/17052-AzulTecnologia"><img
                    src="https://statuspage.freshping.io/badge/533e82de-c259-47ab-a7d5-42ae273af966?0.5757067805614287"/>
                </a>
                <p className="copyright">© Azul Tecnologia - All rights reserved
                    <br/>Versão 2.0</p>
            </footer>
        </div>
    );
};

LoginForm.propTypes = {
    onLogin: PropTypes.func.isRequired,
    error: PropTypes.bool,
    clear: PropTypes.func,
    schema: PropTypes.object,
    loading: PropTypes.bool,
};

export default LoginForm;
